import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Grid, IconButton, Typography, Box, Select, MenuItem, Button, Divider } from '@mui/material';

import { useForm } from 'react-hook-form';
import { WSIcons } from '../../../commonFunctions/iIcons';
import WSTextField, { TextType } from '../../../Components/TextBox/WSTextBox';
import WSPhone from '../../../Components/Phone/WSPhone';
import { customValidation, validations } from '../../../commonFunctions/CommonFunctions';
import WSFileUpload from '../../../Components/FileUpload/WSFileUpload';



interface PropertysetupDialogProps {
  open: boolean;
  onClose: () => void;
}

export const PropertySetup: React.FC<PropertysetupDialogProps> = ({ open, onClose }) => {
  const { register, control } = useForm();

  
  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          style: {
            backgroundColor: 'whitesmoke',
            width: '70vw',
            height: '80vh',
            left:100
          },
        }}
      >
        <DialogTitle>
          <Grid display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" color="blue">
            Property Information
            </Typography>
            <IconButton onClick={onClose}>
              <WSIcons.CloseIcon sx={{ color: 'black' }} />
            </IconButton>
          </Grid>
        </DialogTitle>
        <Divider/>
        <DialogContent>
        <Grid container spacing={2}>
            {/* Left section - Nested Grid for splitting into two parts */}
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                {/* First part of the left section */}
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Property Name</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("name")}
            id="name"
            name="name"
            control={control}
            rules={{ required: false }}
          />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Beneficiary Name</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("beneficiaryname")}
            id="beneficiaryname"
            name="beneficiaryname"
            control={control}
            rules={{ required: false }}
          />
                </Grid>
                <Grid item xs={12}>
<Typography>Address</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
  <Typography variant="body1">Address</Typography>
</Grid>
<Grid item xs={12} sm={6}>
  <Grid container spacing={2}> {/* Add spacing between fields */}
    <Grid item xs={12}>
      <WSTextField
        label={""}
        {...register("addressline1")}
        id="addressline1"
        name="addressline1"
        control={control}
        rules={{ required: false }}
      />
    </Grid>
    <Grid item xs={12}>
      <WSTextField
        label={""}
        {...register("addressline2")}
        id="addressline2"
        name="addressline2"
        control={control}
        rules={{ required: false }}
      />
    </Grid>
  </Grid>
</Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant="body1">City</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("city")}
            id="city"
            name="city"
            control={control}
            rules={{ required: false }}
          /></Grid>
           <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Zip</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("zip")}
            id="zip"
            name="zip"
            control={control}
            rules={{ required: false }}
          /></Grid>
          <Grid item xs={12} sm={6}>
                  <Typography variant="body1">State</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("state")}
            id="state"
            name="state"
            control={control}
            rules={{ required: false }}
          /></Grid>
           <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Country</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("country")}
            id="country"
            name="country"
            control={control}
            rules={{ required: false }}
          /></Grid>
          <Grid item xs={12}>
            <Typography>Contact Information</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Phone</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSPhone label={""} id={"phone"} name={"phone"} control={control} />

               </Grid>
               <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Fax</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("fax")}
            id="fax"
            name="fax"
            control={control}
            rules={{ required: false }}
          />
               </Grid><Grid item xs={12} sm={6}>
                  <Typography variant="body1">Rsrv Phone</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSPhone label={""} id={"rsrvphone"} name={"rsrvphone"} control={control}  />

               </Grid>
               <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Email</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            control={control}
            id="email"
            {...register("email")}
            type={TextType.Text}
            rules={customValidation(true, validations.email)}
            name="email"
            label=" "
          />
               </Grid>
               <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Website</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("website")}
            id="website"
            name="website"
            control={control}
            rules={{ required: false }}
          />
               </Grid>
                </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                <Grid container spacing={2}>
                {/* First part of the left section */}
                <Grid item xs={12} >
                  <Typography variant="body1">Other Information</Typography>
                </Grid>
               <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Property Type</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("propertytype")}
            id="propertytype"
            name="propertytype"
            control={control}
            rules={{ required: false }}
          />
               </Grid>
               <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Property Grade</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("propertygrade")}
            id="propertygrade"
            name="propertygrade"
            control={control}
            rules={{ required: false }}
          />
          </Grid>
          <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Registration No 1</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("registrationno1")}
            id="registrationno1"
            name="registrationno1"
            control={control}
            rules={{ required: false }}
          />
          </Grid>
          <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Registration No 2</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("registrationno2")}
            id="registrationno2"
            name="registrationno2"
            control={control}
            rules={{ required: false }}
          />
          </Grid>
          <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Registration No 3</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("registrationno3")}
            id="registrationno3"
            name="registrationno3"
            control={control}
            rules={{ required: false }}
          />
          </Grid>
          <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Registration No 4</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("registrationno4")}
            id="registrationno4"
            name="registrationno4"
            control={control}
            rules={{ required: false }}
          />
          </Grid>
          <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Registration No 5</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSTextField
            label={""}
            {...register("registrationno5")}
            id="registrationno5"
            name="registrationno5"
            control={control}
            rules={{ required: false }}
          />
          </Grid>
          <Grid item xs={12} sm={6}>
                  <Typography variant="body1">Logo</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                <WSFileUpload
                                id="logo"
                                label=""
                                name="logo"
                                control={control}
                                rules={{ required: true }}
                                acceptFileTypes=".jpg,.png"
                                maxFileSizeMB={20}
                                multiple={true}
                                image={true}
                                align="Start"
                            />
          </Grid>
                </Grid>
                </Grid>
                </Grid>
        </DialogContent>
        <Divider/>
        <Grid
  item
  sx={{
    padding: "1rem",
    display: "flex", // Enable flexbox layout
    justifyContent: "flex-end", // Align items to the right
    gap: "1rem", // Add spacing between buttons
  }}
>
  <Button variant="outlined" sx={{ color: "black", borderColor: "black" }}>
    Save
  </Button>
  <Button variant="outlined" sx={{ color: "black", borderColor: "black" }}>
    Close
  </Button>
</Grid>

      </Dialog>

    
    </>
  );
};

